import React from "react";
import PropTypes from "prop-types";
import Logger from "../commons/Logger";

export default function ForSalePage() {
  Logger.debug("TODO - for sale layout");
  return <div id="forsalePage" />; // TODO: TBD by UX
}

ForSalePage.propTypes = {
  landerConfig: PropTypes.object.isRequired,
  queryConfig: PropTypes.object.isRequired,
};
